import _defineProperty from "/builds/aspendental/web/apps/aspendental-clearchoice-compare/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/builds/aspendental/web/apps/aspendental-clearchoice-compare/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["color", "radioItems", "showInRow", "sx", "value"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import { FormControl, FormControlLabel, Radio, RadioGroup } from '@mui/material';
import { useTheme } from '@mui/material/styles';

var TAGRadioButtonInput = function TAGRadioButtonInput(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'primary' : _ref$color,
      radioItems = _ref.radioItems,
      _ref$showInRow = _ref.showInRow,
      showInRow = _ref$showInRow === void 0 ? true : _ref$showInRow,
      sx = _ref.sx,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? '' : _ref$value,
      props = _objectWithoutProperties(_ref, _excluded);

  var theme = useTheme();
  var transformedColor = color.includes('.') ? color : "".concat(color, ".main");
  return React.createElement(FormControl, null, React.createElement(RadioGroup, _objectSpread(_objectSpread({}, props), {}, {
    row: showInRow,
    sx: sx,
    value: value
  }), radioItems.map(function (item) {
    return React.createElement(FormControlLabel, {
      sx: {
        // color: ASPENDENTAL_COLOR.text.secondary,
        '&.MuiFormControlLabel-root': theme.typography.bodyMediumBook // '& .MuiFormControlLabel-label.Mui-disabled': { color: ASPENDENTAL_COLOR.neutrals[300] },
        // '& .MuiSvgIcon-root': {
        //   color: item.fieldDisabled ? ASPENDENTAL_COLOR.neutrals[300] : ASPENDENTAL_COLOR.secondary[500],
        // },

      },
      disabled: item.fieldDisabled,
      value: item.inputValue,
      label: item.inputLabel,
      key: item.inputLabel,
      control: React.createElement(Radio, {
        disabled: item.fieldDisabled,
        sx: {
          '&.Mui-checked': {
            color: transformedColor
          }
        }
      })
    });
  })));
};

export default TAGRadioButtonInput;